const COLOR_THUMB_SELECTOR = '.js-productCardColorThumb';
const COLOR_MORE_SELECTOR = '.js-productCardColorMore';
const COLOR_TRIGGER_SELECTOR = `${COLOR_THUMB_SELECTOR}, ${COLOR_MORE_SELECTOR}`;

const asElement = (node) => {
  if (!node) return null;
  if (node instanceof Element) return node;
  return node.parentElement;
};

const getCard = (el) => asElement(el)?.closest('.js-productItem');

const hidePreview = (card) => {
  if (!card) return;
  const preview = card.querySelector('.js-productCardColorPreview');
  if (preview) preview.hidden = true;
  card.classList.remove('product-item--colorPreview');
};

const showPreview = (thumb) => {
  const card = getCard(thumb);
  const preview = card?.querySelector('.js-productCardColorPreview');
  const img = card?.querySelector('.js-productCardColorPreviewImg');
  if (!card || !preview || !img) return;

  if (thumb.dataset.current === 'true' || !thumb.dataset.previewSrc) {
    hidePreview(card);
    return;
  }

  if (img.dataset.loadedSrc !== thumb.dataset.previewSrc) {
    img.src = thumb.dataset.previewSrc;
    img.srcset = thumb.dataset.previewSrcset || '';
    img.sizes = thumb.dataset.previewSizes || '25vw';
    img.dataset.loadedSrc = thumb.dataset.previewSrc;
  }

  preview.hidden = false;
  card.classList.add('product-item--colorPreview');
};

document.addEventListener('pointerover', (event) => {
  const thumb = asElement(event.target)?.closest(COLOR_THUMB_SELECTOR);
  if (!thumb) return;
  showPreview(thumb);
});

document.addEventListener('pointerout', (event) => {
  const target = asElement(event.target);
  const thumb = target?.closest(COLOR_THUMB_SELECTOR);
  const card = getCard(target) || getCard(thumb);
  if (!card) return;

  const next = asElement(event.relatedTarget);
  if (next && card.contains(next)) {
    const nextThumb = next.closest(COLOR_THUMB_SELECTOR);
    if (nextThumb && getCard(nextThumb) === card) return;
    if (thumb) hidePreview(card);
    return;
  }

  hidePreview(card);
});

document.addEventListener('focusin', (event) => {
  const thumb = asElement(event.target)?.closest(COLOR_THUMB_SELECTOR);
  if (thumb) showPreview(thumb);
});

document.addEventListener('focusout', (event) => {
  const thumb = asElement(event.target)?.closest(COLOR_THUMB_SELECTOR);
  if (!thumb) return;
  const card = getCard(thumb);
  const next = asElement(event.relatedTarget);
  if (next && getCard(next) === card && next.closest(COLOR_THUMB_SELECTOR)) return;
  hidePreview(card);
});

document.addEventListener('click', (event) => {
  const trigger = asElement(event.target)?.closest(COLOR_TRIGGER_SELECTOR);
  if (!trigger) return;

  event.preventDefault();
  event.stopPropagation();

  const { url } = trigger.dataset;
  if (url) window.location.assign(url);
}, true);
